// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3Qyfy","label":"Section_label__1lCmn","contentWrap":"Section_contentWrap__USv1L","footer":"Section_footer__35OLz","footerInner":"Section_footerInner__1Kq1x"};